export enum PaymentMethodEnum {
    credit_card,
    on_delivery,
    fast_transfer,
    blik,
    in_restaurant,
}
